import { render, staticRenderFns } from "./admin-contactos.vue?vue&type=template&id=5acd0a6d&"
import script from "./admin-contactos.vue?vue&type=script&lang=js&"
export * from "./admin-contactos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports